import { render } from "./ManagerAdminData.vue?vue&type=template&id=7b31277c"
import script from "./ManagerAdminData.vue?vue&type=script&lang=js"
export * from "./ManagerAdminData.vue?vue&type=script&lang=js"

import "./ManagerAdminData.vue?vue&type=style&index=0&id=7b31277c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__